import React from "react";
import { Modal } from "seed/helpers";
import l from "components/util/l";
import FilterForm from "components/collections/table/forms/FilterForm";
import DataForm from "components/collections/table/forms/DataForm";
import ImportForm from "components/collections/table/forms/ImportForm";
import ExportForm from "components/collections/table/forms/ExportForm";
import CloneForm from "components/collections/table/forms/CloneForm";
import SortForm from "components/collections/table/forms/SortForm";
import FilesForm from "components/collections/table/forms/FilesForm";
import TableControls from "components/collections/Table.sub.controls.view";
import TableDatagrid from "components/collections/Table.sub.datagrid.view";
import PaginationFooter from "components/util/helpers/PaginationFooter";

const TableView = ({
  tableRef,
  searchRef,
  flow,
  activeCollection,
  collections = [],
  collectionOptions = {},
  rows = [],
  columns = [],
  primaryKey = null,
  filterDefault = null,
  zipFieldName = null,
  filteredData = [],
  filteredColumns = [],
  formValue,
  selectedCell,
  selectedFile,
  multipleSelectedCells,
  pageNum,
  totalPages,
  query,
  filters,
  search,
  sorting,
  showFilters = true,
  showOptions = true,
  showImport = true,
  showExport = true,
  showSearch = true,
  showSorting = true,
  showForm = false,
  showAdd = false,
  showDelete = false,
  showPermissions = false,
  showManageCollections = false,
  isReadOnly = false,
  isLoading = false,
  isFilePreviewShown = false,
  isFilterModalShown = false,
  isOptionModalShown = false,
  isSingleImport = false,
  isImportModalShown = false,
  isExportModalShown = false,
  isFormModalShown = false,
  isSearchShown = false,
  isSortingModalShown = false,
  isZipModalShown = false,
  isCloneModalShown = false,
  isEditingCell,
  setSelectedCell,
  setSelectedFile,
  setMultipleSelectedCells,
  setFormValue,
  setZipFieldName,
  setIsFilePreviewShown,
  setIsFilterModalShown,
  setIsOptionModalShown,
  setIsSingleImport,
  setIsImportModalShown,
  setIsExportModalShown,
  setIsFormModalShown,
  setIsSearchShown,
  setFilterDefault,
  setIsSortingModalShown,
  setIsZipModalShown,
  setIsCloneModalShown,
  onClickChangeColumn = () => { },
  onClickMoveLeftColumn = () => { },
  onClickMoveRightColumn = () => { },
  onClickDeleteColumn = () => { },
  onAddRow = () => { },
  onClickDeleteRow = () => { },
  onClickDeleteMultipleRows = () => { },
  onClickInsertRow = () => { },
  onClickCloneRow = () => { },
  onChangeRow = () => { },
  onClickImport = () => { },
  onClickExport = () => { },
  onClickDownloadZip = () => { },
  onClickCell = () => { },
  onDoubleClickCell = () => {},
  onBlurCell = () => {},
  onClickSubmitForm = () => { },
  onClickDeleteCollection = () => { },
  onClickClearData = () => { },
  onClickCloneCollection = () => { },
  onClickOpenCollectionEditModal = () => {},
  onClickOpenColumnCreateModal = () => {},
  onClickOpenColumnEditModal = () => {},
  onClickOpenPermissionModal = () => {},
  updateSearch = () => { },
  updateFilters = () => { },
  updateQuery = () => { },
  updateSorting = () => { },
  updatePage = () => { },
  refetchCollections = () => {}
}) => {
  return (
    <div className="h-100 position-relative" id="tables-board">

      <TableControls
        searchRef={searchRef}
        activeCollection={activeCollection}
        flow={flow}
        rows={rows}
        columns={columns}
        search={search}
        filters={filters}
        sorting={sorting}
        multipleSelectedCells={multipleSelectedCells}
        showDelete={showDelete}
        showSearch={showSearch}
        showImport={showAdd && showImport}
        showExport={showExport}
        showForm={showForm}
        showSorting={showSorting}
        showFilters={showFilters}
        showPermissions={showPermissions}
        showManageCollections={showManageCollections}
        isReadOnly={isReadOnly}
        isSearchShown={isSearchShown}
        setIsImportModalShown={setIsImportModalShown}
        setIsSingleImport={setIsSingleImport}
        setIsExportModalShown={setIsExportModalShown}
        setIsFormModalShown={setIsFormModalShown}
        setIsSortingModalShown={setIsSortingModalShown}
        setIsSearchShown={setIsSearchShown}
        setIsFilterModalShown={setIsFilterModalShown}
        setSelectedCell={setSelectedCell}
        setMultipleSelectedCells={setMultipleSelectedCells}
        setIsCloneModalShown={setIsCloneModalShown}
        onClickDownloadZip={onClickDownloadZip}
        onClickDeleteCollection={onClickDeleteCollection}
        onClickClearData={onClickClearData}
        onClickDeleteMultipleRows={onClickDeleteMultipleRows}
        onClickOpenCollectionEditModal={onClickOpenCollectionEditModal}
        onClickOpenPermissionModal={onClickOpenPermissionModal}
        updateSearch={updateSearch}
        refetchCollections={refetchCollections}
      />

      <div className="pb-1" >
        <TableDatagrid
          flow={flow}
          columns={columns}
          rows={filteredData}
          primaryKey={primaryKey}
          filteredData={filteredData}
          filteredColumns={filteredColumns}
          collections={collections}
          collectionOptions={collectionOptions}
          isReadOnly={isReadOnly}
          isLoading={isLoading}
          isFilePreviewShown={isFilePreviewShown}
          isEditingCell={isEditingCell}
          showOptions={showOptions}
          showFilters={showFilters}
          showForm={showForm}
          showSorting={showSorting}
          showAdd={showAdd}
          showDelete={showDelete}
          tableRef={tableRef}
          filters={filters}
          sorting={sorting}
          selectedCell={selectedCell}
          selectedFile={selectedFile}
          multipleSelectedCells={multipleSelectedCells}
          setSelectedCell={setSelectedCell}
          setSelectedFile={setSelectedFile}
          setMultipleSelectedCells={setMultipleSelectedCells}
          setFormValue={setFormValue}
          setZipFieldName={setZipFieldName}
          setIsFilterModalShown={setIsFilterModalShown}
          setIsFilePreviewShown={setIsFilePreviewShown}
          setIsOptionModalShown={setIsOptionModalShown}
          setIsFormModalShown={setIsFormModalShown}
          setIsSortingModalShown={setIsSortingModalShown}
          setIsZipModalShown={setIsZipModalShown}
          setFilterDefault={setFilterDefault}
          onClickChangeColumn={onClickChangeColumn}
          onClickMoveLeftColumn={onClickMoveLeftColumn}
          onClickMoveRightColumn={onClickMoveRightColumn}
          onClickDeleteColumn={onClickDeleteColumn}
          onAddRow={onAddRow}
          onClickDeleteRow={onClickDeleteRow}
          onClickInsertRow={onClickInsertRow}
          onClickCloneRow={onClickCloneRow}
          onChangeRow={onChangeRow}
          onClickDownloadZip={onClickDownloadZip}
          onClickCell={onClickCell}
          onDoubleClickCell={onDoubleClickCell}
          onBlurCell={onBlurCell}
          onClickOpenColumnCreateModal={onClickOpenColumnCreateModal}
          onClickOpenColumnEditModal={onClickOpenColumnEditModal}
        />
      </div>

      {totalPages > 1 ?
        <div className="w-100 px-3 m-0" id="collection-pagination">
          <nav class="mt-n2">
            <PaginationFooter
              pageNum={pageNum}
              totalPages={totalPages}
              onClickPage={updatePage}
            />
          </nav>
        </div> : null}

      {
        isFilterModalShown && <Modal
          width="800"
          height={window.innerHeight - 150}
          columns={columns}
          query={query}
          onClose={() => setIsFilterModalShown(false)}
          component={() =>
            <div className="card card-body w-100">
              <FilterForm
                columns={columns}
                query={query}
                filters={filters}
                filterDefault={filterDefault}
                updateFilters={updateFilters}
                updateQuery={updateQuery}
                onClose={() => setIsFilterModalShown(false)}
              />
            </div>
          }
        />
      }

      {
        isExportModalShown && <Modal
          width={450}
          height={400}
          rows={rows}
          columns={columns}
          activeCollection={activeCollection}
          collections={collections}
          onClickExport={onClickExport}
          onClose={() => setIsExportModalShown(false)}
          component={ExportForm}
        />
      }

      {
        isImportModalShown && <Modal
          width={650}
          height={window.innerHeight - 200}
          collections={collectionOptions}
          activeCollection={activeCollection}
          primaryKey={primaryKey}
          rows={rows}
          columns={columns}
          isSingleImport={isSingleImport}
          onClickImport={onClickImport}
          onClose={() => {
            setIsImportModalShown(false);
            setIsSingleImport(false);
          }}
          component={ImportForm}
        />
      }

      {
        isFormModalShown && <Modal
          width="600"
          height={window.innerHeight - 150}
          title={formValue ? l("Editar dato%CA013") : l("Agregar dato%CA011")}
          structure={columns}
          initialRow={formValue}
          onClickSubmitForm={onClickSubmitForm}
          onClose={() => {
            setIsFormModalShown(false);
            setFormValue(null);
          }}
          component={DataForm}
        />
      }

      {
        isSortingModalShown && <Modal
          width="600"
          height={window.innerHeight - 150}
          columns={columns}
          sorting={sorting}
          updateSorting={updateSorting}
          onClose={() => setIsSortingModalShown(false)}
          component={SortForm}
        />
      }

      {
        isZipModalShown && <Modal
          width="325"
          height="400"
          zipFieldName={zipFieldName}
          onClickDownloadZip={onClickDownloadZip}
          onClose={() => setIsZipModalShown(false)}
          component={FilesForm}
        />
      }

      {
        isCloneModalShown && <Modal
          width="500"
          height={window.innerHeight - 200}
          onClickCloneCollection={onClickCloneCollection}
          onClose={() => setIsCloneModalShown(false)}
          component={CloneForm}
        />
      }

    </div>
  )
}

export default TableView;